import React, { useState } from 'react';
import { LayoutModule } from '../../../layout/modules';
import { LegalProceedingsFilters } from './filters';
import { LegalProceedingsList } from './list';
import { LegalProceedingFilter } from '../../../../shared/types/legalProceedings/legalProceedings';
import { LEGAL_PROCEEDINGS_NEW } from '../../../../routes/paths';
import {
    isOnlyViewProfile,
    isSwitchAgent,
} from '../../../../shared/types/profiles';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';

export const LegalProceedings = () => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const [filters, setFilters] = useState<LegalProceedingFilter>();

    return (
        <>
            <LayoutModule
                title="Búsqueda de procesos judiciales PQR"
                {...(!isOnlyViewProfile(type) &&
                    !isSwitchAgent(type) && {
                    createPath: LEGAL_PROCEEDINGS_NEW,
                })}
            >
                <LegalProceedingsFilters
                    onFilter={(filters) => setFilters(filters)}
                />
            </LayoutModule>
            <LegalProceedingsList filters={filters} />
        </>
    );
};
